import { render } from "./EmbeddedGameWaitingRoom.vue?vue&type=template&id=c1ec1088&scoped=true"
import script from "./EmbeddedGameWaitingRoom.vue?vue&type=script&lang=js"
export * from "./EmbeddedGameWaitingRoom.vue?vue&type=script&lang=js"

import "./EmbeddedGameWaitingRoom.vue?vue&type=style&index=0&id=c1ec1088&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1ec1088"]])

export default __exports__